import Vue from 'vue'

import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  Link,
  Footer,
  MessageBox,
  Option,
  Select,
  Tree,
  Tag,
  Alert,
  DatePicker,
  Transfer,
  Cascader,
  Tabs,
  TabPane,
  ButtonGroup,
  Upload,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Carousel,
  CarouselItem,
  Divider,
  Progress,
  Popover,
  InputNumber,
  Empty,
  CheckboxGroup,
  Checkbox,
  Drawer,
  Badge,
  OptionGroup,
  RadioGroup,
  Radio,
  Notification,
  MenuItemGroup
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Link)
Vue.use(Footer)
Vue.use(Option)
Vue.use(Select)
Vue.use(Tree)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(DatePicker)
Vue.use(Transfer)
Vue.use(Cascader)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(ButtonGroup)
Vue.use(Upload),
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Loading)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Divider)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(InputNumber)
Vue.use(Empty)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Drawer)
Vue.use(Badge)
Vue.use(OptionGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(MenuItemGroup)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
